// Libraries

// Layouts

// Components
import {
    Table,
    Popup,
    FormElems,
    AddComm,
    EditViewComm,
} from '../../components';

// Constants
import { TAB_LIST } from '../../utils/constants/commonValues';

// Actions
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import ComTabs from './ComTabs';

import {
    fetchNotificationEventRequest,
    fetchCommProfileRequest,
} from './redux/commProfile.actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';

// Styles
import './commProfile.scss';

const getTableData = (commData, selectedTab) => {
    if (selectedTab === 'WEBHOOK') {
        return commData.webhook;
    } else if (selectedTab === 'SMS') {
        return commData.sms;
    }
    return commData.email;
};

const getHeaderName = selectedTab => {
    let headerName = 'Email ID';
    if (selectedTab === 'WEBHOOK') {
        headerName = 'Url';
    } else if (selectedTab === 'SMS') {
        headerName = 'SMS Number';
    }
    return headerName;
};

const CommProfileActions = ({ data, selectedTab, fetchData }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData();
        }
    };
    return (
        <div className="userAction  multiItem">
            <button
                className="edit"
                onClick={() => handleOpenActionPopup('EDIT')}
            />
            <button
                className="view"
                onClick={() => handleOpenActionPopup('VIEW')}
            />
            <Popup
                title={data.original.identifier}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <EditViewComm
                    actionType={actionType}
                    data={data.original}
                    selectedTab={selectedTab}
                    initialValues={data.original}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const AddActions = ({ fetchData, selectedTab, isDisable }) => {
    const [showFilter, setShowFilter] = useState(false);
    const handleOpenActionPopup = () => {
        setShowFilter(true);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        if (isFetch && !isFetch.target) {
            fetchData();
        }
    };

    const getTabName = selectedTab => {
        if (selectedTab) {
            const tabName = TAB_LIST.find(item => item.value === selectedTab);
            return (tabName && tabName.label) || '';
        }
        return '';
    };
    return (
        <div className="mail-head clearfix">
            <div className="headTitle">
                <p>{getTabName(selectedTab)} Profile</p>
            </div>
            <div className="head-action">
                <FormElems.Button
                    buttonType="primary"
                    text={`ADD ${selectedTab}`}
                    type="button"
                    customClass="action-button"
                    handleClick={handleOpenActionPopup}
                    isDisable={isDisable}
                />
                <Popup
                    title={`ADD ${selectedTab}`}
                    showCloseIcon
                    showOverlay
                    showFilter={showFilter}
                    closePopup={handleCloseOpenActionPopup}
                >
                    <AddComm
                        selectedTab={selectedTab}
                        closePopup={handleCloseOpenActionPopup}
                    />
                </Popup>
            </div>
        </div>
    );
};

const CommProfile = props => {
    const {
        commData,
        actions,
        loader: { showLoader },
        auth,
    } = props;

    const { error, isLoading } = commData;
    const { userDetails } = auth;

    // We'll start our table without any data
    const [selectedTab, setSelectedTab] = useState('EMAIL');

    const fetchData = useCallback(() => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,

        actions.fetchCommProfileRequest();
    }, [actions]);

    useEffect(() => {
        actions.fetchNotificationEventRequest();
    }, [actions]);

    const headerName = getHeaderName(selectedTab);

    const columns = useMemo(
        () => [
            { header: headerName, accessor: 'identifier' },
            { header: 'Created Date', accessor: 'createdOn' },
            { header: 'Merchant', accessor: 'noOfMerchants' },
            { header: 'Status', accessor: 'status' },
            { header: 'Event', accessor: 'eventsListView' },
            { header: 'Action', accessor: 'action' },
        ],
        [headerName]
    );

    const tableData = getTableData(commData, selectedTab);

    return (
        <div className="comm-profile-wrapper">
            <Table
                tableTitle="Communication Profile"
                columns={columns}
                isFiltersEnable
                tableHead={
                    <AddActions
                        fetchData={fetchData}
                        selectedTab={selectedTab}
                        isDisable={userDetails.userLevel === 'ADMIN'}
                    />
                }
                data={tableData || []}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                fetchData={fetchData}
                userActions={data => (
                    <CommProfileActions
                        data={data}
                        selectedTab={selectedTab}
                        fetchData={fetchData}
                    />
                )}
                tableFilters={
                    <ComTabs
                        tabList={TAB_LIST}
                        selectedTab={selectedTab}
                        setSelectedTab={tab => {
                            setSelectedTab(tab);
                        }}
                    />
                }
            />
        </div>
    );
};

const mapStateToProps = ({ auth, commData, loader }) => ({
    auth,
    commData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            fetchNotificationEventRequest,
            fetchCommProfileRequest,
        },
        dispatch
    ),
});

CommProfile.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    commData: PropTypes.object,
    loader: PropTypes.object,
};

CommProfileActions.propTypes = {
    data: PropTypes.object,
    selectedTab: PropTypes.string,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

AddActions.propTypes = {
    selectedTab: PropTypes.string,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
    isDisable: PropTypes.bool,
};
export default connect(mapStateToProps, mapDispatchToProps)(CommProfile);
